import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _Object$freeze from "@babel/runtime-corejs3/core-js-stable/object/freeze";
import { useState } from 'react';
import { useRefFrom } from 'use-ref-from';
export default function useStateWithRef(initialState) {
  var _useState = useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    value = _useState2[0],
    setter = _useState2[1];
  return _Object$freeze([value, setter, useRefFrom(value)]);
}
//# sourceMappingURL=useStateWithRef.js.map